import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from "@angular/core";

@Component({
  selector: "[wall-type-6]",
  templateUrl: "./wall-type-6.component.html",
  styleUrls: ["./wall-type-6.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class WallType6Component {
  height = input<number>();

  leftWallPoints = computed(() => this.getWallPoints(this.height(), "left"));
  rightWallPoints = computed(() => this.getWallPoints(this.height(), "right"));

  // Space_config
  private getWallPoints(baseHeight: number, wallSide: "left" | "right"): string {
    const wallData = {
        left: `M0 101 L137 168 L137 ${baseHeight + 37} L0 ${baseHeight - 30} Z`,
        right: `M137 168 L274 101 L274 ${baseHeight - 30} L137 ${baseHeight + 37} Z`
    };

    return wallData[wallSide];
  }
}
